export default {
  components: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down('lg')]: {
          fontSize: 14,
          marginBottom: theme.spacing(0)
        }
      })
    }
  }
};
